class FaqCenter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.categoryList = this.querySelector('[data-category-list]');
    this.questionList = this.querySelector('[data-question-list]');
    this.categoryTitle = this.querySelector('[data-category-title]');

    this.categoryList.addEventListener('change', (event) => {
      if (event.target.type === 'radio') this.onCategoryChange(event.target);
    });

    const checked = this.categoryList.querySelector('input[type="radio"]:checked');
    if (checked) this.onCategoryChange(checked);
  }

  onCategoryChange(radio) {
    const value = radio.value;
    const label = radio.closest('label');
    const labelSpan = label.querySelector('[data-category-label]');

    this.categoryTitle.textContent = labelSpan?.textContent.trim() ?? value;

    this.questionList.querySelectorAll('[data-category]').forEach((li) => {
      const match = li.dataset.category === value;
      li.hidden = !match;
      li.classList.toggle('hidden', !match);
    });
  }
}

customElements.define('faq-center', FaqCenter);